// import { Text } from '@pancakeswap-libs/uikit'
import styled from 'styled-components'

export const Title = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #280D5F;
  line-height: 20px;
  padding: 28px 24px;
  background: linear-gradient(103deg, #F2ECF2, #E8F2F6);
`
export const InputBox = styled.div`
  margin-bottom: 20px;
`
export const InputTitle = styled.div`
  font-size: 14px;
  color: #280D5F;
  margin-bottom: 10px;
`
export const WarnTip = styled.div`
  font-size: 13px;
  color: #7A6EAA;
  line-height: 23px;
  padding: 15px 15px;
  // background: #FFF6E8;
  // border: 1px solid #FFC323;
  border-radius: 12px;
  margin-bottom: 20px;
  b{
    color: #280D5F;
  }
`
export const Wrapper = styled.div`
  position: relative;
`

export const LockInputBox = styled.div`
  background: #EEEAF4;
  height: 46px;
  border-radius: 16px;
  border: 1px solid #D7CAEC;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  position: relative;
  margin-bottom: 20px;
`

export const Icon = styled.img<{ size: string }>`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
`
export const TokenPopBox = styled.div`
  background: #fff;
  position: absolute;
  width: 100%;
  padding: 15px 0;
  box-sizing: border-box;
  border-radius: 12px;
  top: 50px;
  right: 0;
  z-index: 100;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
`
export const TokenPopItem = styled.div`
  height: 30px;
  line-height: 30px;
  padding: 0 15px;
  font-size: 15px;
  color: #280D5F;
  font-weight: bold;
  &.active{
    color: #1EC7D3;
  }
`
export const LockText = styled.div`
  font-size: 14px;
  color: #280D5F;
  font-weight: bold;
`
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;

  width: 100%;
  padding: 32px 16px;

  background-image: url('./images/createTop.png');
  background-repeat: no-repeat;
  background-position: center 24px;
  background-size: 80%;

  ${({ theme }) => theme.mediaQueries.xs} {
    background-size: 80%;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    background-image: url('./images/createTop.png');
    background-repeat: no-repeat;
    background-position: center 24px;
    background-size: 400px;
    min-height: 90vh;
  }
  
`
export const SwitchIcon = styled.img<{ width: string, height: string}>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  display: block;
  margin-top: 5px;
`
